"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asMasked = void 0;

var _string = require("../type-checks/string");

var asMasked = function asMasked(input) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    leadCharsExposed: 0,
    maskingChar: "*",
    trailingCharsExposed: 4
  };
  var returnElem = input,
      i = 0;

  if ((0, _string.isStringOfLength)(input)) {
    if (input.length > config.leadCharsExposed + config.trailingCharsExposed) {
      returnElem = input.replace(/./g, function (currentChar) {
        var targetChar = currentChar;

        if (i >= config.leadCharsExposed && i < input.length - config.trailingCharsExposed) {
          targetChar = config.maskingChar;
        }

        i += 1;
        return targetChar;
      });
    }
  }

  return returnElem;
};

exports.asMasked = asMasked;